var map = {
	"./accounts-logo.svg": "c535",
	"./ecart-pay-color.svg": "f24a",
	"./ecart-seller-color.svg": "98fc",
	"./ecart-seller-white.svg": "b14d",
	"./ecartpay-white.svg": "e4a9",
	"./envia.svg": "6eed0",
	"./fulfillment-mibox.svg": "82e8",
	"./fulfillment.svg": "af70",
	"./returns-color.svg": "b83d",
	"./returns-white.svg": "4ffb",
	"./wms.svg": "83e1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cda2";